import { axInst, axInstBasic } from "../../../components/Service/Service";

export const getArnPayload = (parArn, childArn, filters = {}) => {
  // console.log("ParArn, ChildArn, Filters:", parArn, childArn, filters);

  let payload = {};

  if (childArn) {
    payload.childArn = childArn;
  } else if (parArn) {
    payload.parArn = parArn;
  } else {
    throw new Error("No ARN provided for complaints count filter.");
  }

  // Merge filters (like category) into payload
  return { ...payload, ...filters };
};

export const fetchallJobCardDetails = async (
  parArn,
  childArn,
  status,
  category,
  filterPayload
) => {
  const payload = {
    ...getArnPayload(parArn, childArn),
    ...filterPayload,
    category,
    status,
  };

  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}all-JobCard-Details`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching complaints average:", error);
    throw error;
  }
};

export const fetchallJobCardDetailsclosed = async (
  parArn,
  childArn,
  status,
  category,
  filterPayload
) => {
  const payload = {
    ...getArnPayload(parArn, childArn),
    ...filterPayload,
    category,
    status,
  };

  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}all-JobCard-Details`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching complaints average:", error);
    throw error;
  }
};

export const fetchallJobCardDetailsopen = async (
  parArn,
  childArn,
  status,
  category
) => {
  const payload = {
    ...getArnPayload(parArn, childArn),
    category,
    status,
  };

  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}all-JobCard-Details`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching complaints average:", error);
    throw error;
  }
};

export const fetchJobCardDetailsAvgTat = async (
  parArn, 
  childArn, 
  jcStatus, // e.g., "Open", "Closed", or "All"
  jcType    // e.g., "Accidental" or "Non-Accidental"
) => {
  
  // Use the requested keys for filtering:
  const filters = {
    // Map the Job Card Type to the key 'category'
    category: jcType, 
    // Map the Job Card Status to the key 'status'
    status: jcStatus, 
  };
  
  // getArnPayload handles parArn/childArn logic and merges the filters
  const payload = getArnPayload(parArn, childArn, filters);
  
  // Example payload sent to API: 
  // { "parArn": "AR02-", "category": "Non-Accidental", "status": "Closed" }

  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}Job-CardDetails-AvgTat`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching job card average TAT:", error);
    throw error;
  }
};

export const fetchjobCardInvoiceAmount = async (parArn, childArn, category) => {
  const payload = {
    ...getArnPayload(parArn, childArn),
    category,
  };

  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}job-Card-InvoiceAmount`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching complaints average:", error);
    throw error;
  }
};

export const fetchJcstategraphdata = async (
  parArn,
  childArn,
  filterPayload
) => {
  const payload = {
    ...getArnPayload(parArn, childArn),
    ...filterPayload,
  };

  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}Jc-state-graph-data`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching complaints average:", error);
    throw error;
  }
};

export const fetchJcMonthWiseGraphData = async (
  parArn,
  childArn,
  filterPayload
) => {
  const payload = {
    ...getArnPayload(parArn, childArn),
    ...filterPayload,
  };

  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}Jc-MonthWise-Graph-Data`,
      payload
    );
    // console.log("res", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching complaints average:", error);
    throw error;
  }
};
export const fetchpplWiseGraphData = async (
  parArn,
  childArn,
  filterPayload
) => {
  const payload = {
    ...getArnPayload(parArn, childArn),
    ...filterPayload,
  };

  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}ppl-Wise-Graph-Data`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching complaints average:", error);
    throw error;
  }
};

export const fetchdealerWiseTableData = async (
  parArn,
  childArn,
  filterPayload
) => {
  const payload = {
    ...getArnPayload(parArn, childArn),
    ...filterPayload,
  };

  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}dealerWiseTableData`,
      payload
    );
    // console.log("table", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching complaints average:", error);
    throw error;
  }
};
export const fetchserviceTypeWiseCountData = async (
  parArn,
  childArn,
  filterPayload
) => {
  const payload = {
    ...getArnPayload(parArn, childArn),
    ...filterPayload,
  };

  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}service-Type-Wise-CountData`,
      payload
    );
    // console.log("table", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching complaints average:", error);
    throw error;
  }
};

export const fetchlobWiseBoxesData = async (
  parArn,
  childArn,
  filterPayload
) => {
  const payload = {
    ...getArnPayload(parArn, childArn),
    ...filterPayload,
  };

  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}lob-Wise-Boxes-Data`,
      payload
    );
    // console.log("table", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching complaints average:", error);
    throw error;
  }
};

export const lobPplPlWiseCountData = async (
  parArn,
  childArn,
  filterPayload
) => {
  const payload = {
    ...getArnPayload(parArn, childArn),
    ...filterPayload,
  };

  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}lob-Ppl-Pl-WiseCountData`,
      payload
    );
    // console.log("table", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching complaints average:", error);
    throw error;
  }
};

export const fetchplListJcDetails = async (parArn, childArn, jcPayload) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);
    const values = {
      ...arnPayload,
      ...jcPayload,
    };

    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}plListJcDetails`,
      values
    );

    // console.log("API response (plListJcDetails):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching plListJcDetails:", error);
    throw error;
  }
};

export const fetchPplListJcDetails = async (parArn, childArn, jcPayload) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);
    const values = {
      ...arnPayload,
      ...jcPayload,
    };

    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}pplListJcDetails`,
      values
    );

    // console.log("API response (pplListJcDetails):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching pplListJcDetails:", error);
    throw error;
  }
};

export const fetchlobListJcDetails = async (parArn, childArn, jcPayload) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);
    const values = {
      ...arnPayload,
      ...jcPayload,
    };

    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}lobListJcDetails`,
      values
    );

    // console.log("API response (lobListJcDetails):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching lobListJcDetails:", error);
    throw error;
  }
};

export const fetchyearListJcDetails = async (parArn, childArn, jcPayload) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);
    const values = {
      ...arnPayload,
      ...jcPayload,
    };

    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}yearListJcDetails`,
      values
    );

    // console.log("API response (yearListJcDetails):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching yearListJcDetails:", error);
    throw error;
  }
};

export const fetchstateListJcDetails = async (parArn, childArn, jcPayload) => {
  try {
    const arnPayload = getArnPayload(parArn, childArn);
    const values = {
      ...arnPayload,
      ...jcPayload,
    };

    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}stateListJcDetails`,
      values
    );

    // console.log("API response (stateListJcDetails):", res.data);
    return res.data.result;
  } catch (error) {
    console.error("Error fetching stateListJcDetails:", error);
    throw error;
  }
};

export const getJcJobCardTatChart = async (parArn, childArn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}jcJobCardTatChart`,
      {parArn, childArn}
    );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching jcJobCardTatChart:", error);
    throw error;
  }
};
